<template>
  <div class="home">
    <div v-if="user">
        <HomeDebugModeToggle />
        <HomeWelcomeMessage/>
        <HomeStudentList/>
        <HomeMemberContent/>
        <HomeLinkedAccount/>
    </div>
    <div v-else class="container text-center p-4">
      <div class="custom-spinner pull-center mt-2"></div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import HomeDebugModeToggle from './HomeDebugModeToggle.vue';
import HomeWelcomeMessage from './HomeWelcomeMessage.vue';
import HomeStudentList from './HomeStudentList.vue';
import HomeMemberContent from './HomeMemberContent.vue';
import HomeLinkedAccount from './HomeLinkedAccount.vue';

export default {
    name: "home",
    components: {
        HomeDebugModeToggle,
        HomeStudentList,
        HomeWelcomeMessage,
        HomeMemberContent,
        HomeLinkedAccount
    },
    computed: mapState( [
        "user",
        "semester",
        "settings",
        "permissions"
    ])
}
</script>
<style scoped>
    .top-card-nav {
        display: inline-grid;
        grid-template-columns: auto auto;
        overflow-x: scroll;
    }
    .top-card-nav::-webkit-scrollbar {
        display: none;
    }
    .top-card-nav > * {
        border-radius: 5px;
        margin-right: 5px;
        padding: 8px 16px;
        font-size: 20px;
    }
    .top-card-nav > *:hover {
        text-decoration: none;
    }
    @media only screen and (min-width: 600px) {
        .top-card-nav > * {
        border-radius: 1rem;
        margin-right: 1rem;
        padding: 1rem 2rem;
        font-size: 3rem;
        }
    }
</style>